/* D-only source tabs, the public native Judge.me feed, and its complete widget. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.proofReady) return;
    const tabs = Array.from(root.querySelectorAll('[data-huh-proof-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-huh-proof-panel]'));
    const tablist = root.querySelector('[data-huh-proof-tabs]');
    if (!tablist || !tabs.length || tabs.length !== panels.length) return;
    root.dataset.proofReady = 'true';

    function selectTab(index, focus) {
      tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
        if (i !== index) panels[i].querySelectorAll('video').forEach(function (video) { video.pause(); });
      });
      if (focus) tabs[index].focus();
      // The shared App Store carousel measures its now-visible track on resize.
      window.dispatchEvent(new Event('resize'));
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectTab(index, false); });
      tab.addEventListener('keydown', function (event) {
        const next = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        selectTab(next, true);
      });
    });
    selectTab(0, false);
    tablist.hidden = false;

    const previewGrid = root.querySelector('[data-huh-judge-previews]');
    const widget = root.querySelector('.jdgm-review-widget');
    const ratingSummary = root.querySelector('[data-huh-judge-rating]');
    const ratingTotals = root.querySelector('[data-huh-judge-totals]');
    let stopNativePreviews = function () {};
    if (widget && ratingSummary && ratingTotals) {
      function renderRating() {
        const stats = widget.querySelector('.jdgm-rev-widg');
        if (!stats) return false;
        const averageValue = stats.getAttribute('data-average-rating');
        const countValue = stats.getAttribute('data-number-of-reviews');
        const average = Number(averageValue);
        const count = Number(countValue);
        if (!averageValue || !countValue || !Number.isFinite(average) || average <= 0 || average > 5 || !Number.isSafeInteger(count) || count < 1) return false;
        ratingTotals.textContent = average.toFixed(2) + ' / 5 · ' + count.toLocaleString('en-US') + (count === 1 ? ' review' : ' reviews');
        ratingTotals.hidden = false;
        ratingSummary.dataset.ratingReady = 'true';
        return true;
      }
      if (!renderRating() && 'MutationObserver' in window) {
        const ratingObserver = new window.MutationObserver(function () {
          if (renderRating()) ratingObserver.disconnect();
        });
        ratingObserver.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews'] });
      }
    }
    if (previewGrid && widget) {
      const controls = root.querySelector('[data-huh-judge-controls]');
      const previous = root.querySelector('[data-huh-judge-prev]');
      const next = root.querySelector('[data-huh-judge-next]');
      const range = root.querySelector('[data-huh-judge-range]');
      const more = root.querySelector('[data-huh-judge-more]');
      const status = root.querySelector('[data-huh-judge-status]');
      const reviewSelector = '.jdgm-rev-widg__reviews > .jdgm-rev[data-review-id]';
      const pageSize = 15;
      const reviewIds = new Set();
      const excerpts = [];
      let observer;
      let nativeFrozen = false;
      let feed;
      let started = false;
      let loading = false;
      let exhausted = false;
      let nextPage = 1;

      function readReviews(source) {
        return Array.from(source.querySelectorAll(reviewSelector)).map(function (review) {
          const id = review.getAttribute('data-review-id');
          const rating = review.querySelector('.jdgm-rev__rating');
          const score = Number(rating && rating.getAttribute('data-score'));
          const body = review.querySelector('.jdgm-rev__body');
          const paragraphs = body ? Array.from(body.querySelectorAll('p')) : [];
          const content = paragraphs.length ? paragraphs.map(function (p) { return p.textContent.trim(); }).join(' ') : (body ? body.textContent.trim() : '');
          if (!id || !Number.isInteger(score) || score < 1 || score > 5 || !content) return null;
          const title = review.querySelector('.jdgm-rev__title');
          const author = review.querySelector('.jdgm-rev__author');
          const timestamp = review.querySelector('.jdgm-rev__timestamp');
          return { id: id, score: score, body: content, title: title ? title.textContent.trim() : '', author: author && author.textContent.trim() ? author.textContent.trim() : 'Customer', date: timestamp && timestamp.getAttribute('datetime') };
        }).filter(Boolean);
      }

      function geometry() {
        const cards = Array.from(previewGrid.children);
        const width = previewGrid.clientWidth;
        if (!cards.length || !width) return { index: 0, visible: 1, step: 1 };
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
        const visible = Math.max(1, Math.floor((width + 16) / (step || 1)));
        return { index: Math.min(cards.length - visible, Math.max(0, Math.round(previewGrid.scrollLeft / (step || 1)))), visible: visible, step: step };
      }

      function updateControls() {
        const count = previewGrid.children.length;
        if (controls) controls.hidden = !count;
        if (!count) return;
        const position = geometry();
        const first = Math.max(0, position.index) + 1;
        const last = Math.min(count, first + position.visible - 1);
        if (range) range.textContent = first + (last > first ? '–' + last : '') + ' of ' + count + ' loaded';
        if (previous) previous.disabled = previewGrid.scrollLeft <= 1;
        if (next) next.disabled = previewGrid.scrollLeft >= previewGrid.scrollWidth - previewGrid.clientWidth - 1;
      }

      function move(direction) {
        const position = geometry();
        let left = (position.index + direction * position.visible) * position.step;
        if (direction === -Infinity) left = 0;
        if (direction === Infinity) left = previewGrid.scrollWidth;
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        previewGrid.scrollTo({ left: left, behavior: reducedMotion ? 'auto' : 'smooth' });
      }
      function updateExcerpts() {
        excerpts.forEach(function (excerpt) {
          excerpt.button.hidden = excerpt.body.dataset.expanded !== 'true' && excerpt.body.scrollHeight <= excerpt.body.clientHeight + 1;
        });
      }
      if (previous) previous.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      previewGrid.addEventListener('scroll', updateControls, { passive: true });
      previewGrid.addEventListener('keydown', function (event) {
        if (event.target !== previewGrid) return;
        const direction = { ArrowLeft: -1, ArrowRight: 1, Home: -Infinity, End: Infinity }[event.key];
        if (direction === undefined) return;
        event.preventDefault();
        move(direction);
      });
      window.addEventListener('resize', function () { updateControls(); updateExcerpts(); });

      function appendReviews(reviews) {
        let added = 0;
        reviews.forEach(function (review) {
          if (reviewIds.has(review.id)) return;
          reviewIds.add(review.id);
          const card = document.createElement('article');
          card.className = 'huh-judge-preview';
          card.setAttribute('data-review-id', review.id);
          function append(tag, className, text) {
            const element = document.createElement(tag);
            element.className = className;
            element.textContent = text;
            card.appendChild(element);
            return element;
          }
          const stars = append('div', 'huh-judge-preview-stars', '★'.repeat(review.score) + '☆'.repeat(5 - review.score));
          stars.setAttribute('aria-label', review.score + ' out of 5 stars');
          if (review.title) append('h4', 'huh-judge-preview-title', review.title);
          const body = append('p', 'huh-judge-preview-body', review.body);
          body.id = previewGrid.id + '-body-' + reviewIds.size;
          body.dataset.expanded = 'false';
          const expand = append('button', 'huh-judge-preview-expand', 'Read more');
          expand.setAttribute('type', 'button');
          expand.setAttribute('aria-expanded', 'false');
          expand.setAttribute('aria-controls', body.id);
          expand.addEventListener('click', function () {
            const expanded = body.dataset.expanded !== 'true';
            body.dataset.expanded = String(expanded);
            expand.setAttribute('aria-expanded', String(expanded));
            expand.textContent = expanded ? 'Read less' : 'Read more';
          });
          excerpts.push({ body: body, button: expand });
          append('span', 'huh-judge-preview-author', review.author);
          const date = review.date ? new Date(review.date) : null;
          if (date && !Number.isNaN(date.getTime())) {
            const time = append('time', 'huh-judge-preview-date', new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(date));
            time.setAttribute('datetime', review.date);
          }
          previewGrid.appendChild(card);
          added++;
        });
        previewGrid.hidden = !reviewIds.size;
        updateExcerpts();
        updateControls();
        return added;
      }

      stopNativePreviews = function () {
        nativeFrozen = true;
        if (observer) observer.disconnect();
      };

      function nativeFeed() {
        if (!window.fetch || !window.DOMParser) return null;
        const pagination = widget.querySelector('.jdgm-paginate');
        const endpoint = pagination && pagination.getAttribute('data-url');
        const productId = widget.getAttribute('data-id');
        const shop = root.dataset.reviewShop;
        if (!endpoint || !/^\d+$/.test(productId || '') || !/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop || '')) return null;
        try {
          const url = new URL(endpoint);
          if (!['https://api.judge.me', 'https://cdn.judge.me'].includes(url.origin) || url.pathname !== '/reviews/reviews_for_widget') return null;
        } catch (_) { return null; }
        return { shop: shop, productId: productId };
      }

      async function loadMore() {
        if (!feed || loading || exhausted) return;
        loading = true;
        const page = nextPage;
        if (more) { more.hidden = false; more.disabled = true; more.textContent = 'Loading reviews…'; }
        if (status) status.hidden = true;
        previewGrid.setAttribute('aria-busy', 'true');
        // This is the public CDN feed used by the native widget. No API key,
        // native widget settings, rating filter or pagination clicks are involved.
        const url = new URL('https://cdn.judge.me/reviews/reviews_for_widget');
        Object.entries({ shop_domain: feed.shop, platform: 'shopify', product_id: feed.productId, per_page: pageSize, page: page }).forEach(function (entry) { url.searchParams.set(entry[0], entry[1]); });
        const controller = window.AbortController ? new window.AbortController() : null;
        let timer;
        try {
          const payload = await Promise.race([
            window.fetch(url.toString(), { credentials: 'omit', signal: controller ? controller.signal : undefined }).then(function (response) {
              if (!response.ok) throw new Error('Review request failed');
              return response.json();
            }),
            new Promise(function (_, reject) { timer = window.setTimeout(function () { if (controller) controller.abort(); reject(new Error('Review request timed out')); }, 10000); })
          ]);
          if (!payload || typeof payload.html !== 'string' || (payload.page != null && Number(payload.page) !== page)) throw new Error('Invalid review response');
          // Parse off-document, then copy text only. Never mount provider HTML in the carousel.
          const source = new window.DOMParser().parseFromString(payload.html, 'text/html');
          const reviews = readReviews(source);
          const total = Number(payload.total_count);
          if (!reviews.length && total !== 0) throw new Error('No review content returned');
          const added = appendReviews(reviews);
          nextPage = page + 1;
          exhausted = (page > 1 && !added) || (Number.isSafeInteger(total) && total >= 0 ? page * pageSize >= total : reviews.length < pageSize);
          stopNativePreviews();
          if (more) { more.hidden = exhausted; more.textContent = 'Load more reviews'; }
        } catch (_) {
          if (more) { more.hidden = false; more.textContent = 'Try again'; }
          if (status) { status.hidden = false; status.textContent = 'More reviews couldn’t load. Try again or read all reviews below.'; }
        } finally {
          window.clearTimeout(timer);
          loading = false;
          if (more) more.disabled = false;
          previewGrid.setAttribute('aria-busy', 'false');
          updateControls();
        }
      }

      function renderNative() {
        if (nativeFrozen) return;
        appendReviews(readReviews(widget));
        if (!started && (feed = nativeFeed())) { started = true; loadMore(); }
      }
      if (more) more.addEventListener('click', loadMore);
      renderNative();
      if ('MutationObserver' in window) {
        observer = new window.MutationObserver(renderNative);
        observer.observe(widget, { childList: true, subtree: true, characterData: true });
      }
    }

    const dialog = root.querySelector('[data-huh-reviews-dialog]');
    const opener = root.querySelector('[data-huh-reviews-open]');
    if (!dialog || typeof dialog.showModal !== 'function' || !opener) return;
    const closeButton = dialog.querySelector('[data-huh-reviews-close]');
    const writeOpener = root.querySelector('[data-huh-review-write]');
    let returnFocus = opener;
    let pendingWrite = false;
    let writeLoadRequested = false;
    let writeActivated = false;
    let writeObserver;
    let writeTimer;
    let writeCheckTimer;

    function stopWriteFocus() {
      pendingWrite = false;
      if (writeObserver) writeObserver.disconnect();
      window.clearTimeout(writeTimer);
      window.clearTimeout(writeCheckTimer);
    }

    function focusReviewForm() {
      if (!pendingWrite || !dialog.open) return false;
      const form = widget && widget.querySelector('.jdgm-form');
      const field = form && Array.from(form.querySelectorAll('input:not([type="hidden"]), textarea, select')).find(function (control) {
        return !control.disabled && control.getClientRects().length;
      });
      if (!field) return false;
      field.focus();
      stopWriteFocus();
      return true;
    }

    function activateNativeWrite() {
      if (!pendingWrite || !dialog.open || focusReviewForm()) return;
      const nativeWrite = widget.querySelector('.jdgm-write-rev-link');
      const form = widget.querySelector('.jdgm-form');
      const ready = form && nativeWrite && nativeWrite.getAttribute('aria-expanded') === 'false' && window.jdgm && typeof window.jdgm._appendCustomForm === 'function';
      if (ready && !writeActivated) {
        writeActivated = true;
        nativeWrite.click();
      } else if (nativeWrite && !form && !writeLoadRequested) {
        // One click starts Judge.me's lazy loader; checks below never re-click it.
        writeLoadRequested = true;
        nativeWrite.click();
      }
      if (!focusReviewForm()) scheduleWriteCheck(100);
    }

    function scheduleWriteCheck(delay) {
      if (!pendingWrite || !dialog.open) return;
      window.clearTimeout(writeCheckTimer);
      writeCheckTimer = window.setTimeout(activateNativeWrite, delay);
    }

    function openReviews(event) {
      // Keep modified clicks and open-in-new-tab behavior available on the source link.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return false;
      event.preventDefault();
      event.stopPropagation();
      returnFocus = event.currentTarget === writeOpener ? writeOpener : opener;
      if (dialog.open) return true;
      stopNativePreviews();
      dialog.showModal();
      closeButton.focus();
      window.requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
      return true;
    }
    opener.setAttribute('aria-haspopup', 'dialog');
    opener.setAttribute('aria-controls', dialog.id);
    opener.addEventListener('click', openReviews);
    closeButton.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () {
      stopWriteFocus();
      if (returnFocus.isConnected) returnFocus.focus();
    });

    if (writeOpener && widget) {
      writeOpener.setAttribute('aria-haspopup', 'dialog');
      writeOpener.setAttribute('aria-controls', dialog.id);
      writeOpener.addEventListener('click', function (event) {
        const nativeWrite = widget.querySelector('.jdgm-write-rev-link');
        if (!nativeWrite || typeof nativeWrite.click !== 'function' || !openReviews(event)) return;
        stopWriteFocus();
        pendingWrite = true;
        writeLoadRequested = false;
        writeActivated = false;
        writeTimer = window.setTimeout(stopWriteFocus, 10000);
        if ('MutationObserver' in window) {
          writeObserver = new window.MutationObserver(focusReviewForm);
          writeObserver.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-expanded'] });
        }
        activateNativeWrite();
      });
      // Judge.me emits this midway through widget_form.js, before defining the
      // _appendCustomForm helper its handler calls. Wait for the script to finish
      // and check readiness; at most one activation occurs per explicit request.
      document.addEventListener('jdgm.doneSetupReviewForm', function () { scheduleWriteCheck(0); });
    }

    // Judge.me's badge normally scrolls to the widget. On D, reveal it first.
    const badge = root.querySelector('[data-huh-judge-badge]');
    if (badge) badge.addEventListener('click', openReviews, true);
  }

  document.querySelectorAll('[data-huh-proof]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-huh-proof]').forEach(init);
  });
}());
